import { useEffect, useState } from 'react';

// material-ui
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project imports
import MainCard from 'components/MainCard';
import { apiRequest } from 'utils/api';
import { getAuthSession } from 'utils/auth';

// ==============================|| DRAWER - ADMIN API HEALTH CARD ||============================== //

export default function AdminHealthCard() {
  const role = getAuthSession()?.user?.role;
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    if (role !== 'Administrator') return;

    let isMounted = true;

    const check = async () => {
      try {
        const response = await apiRequest('/api/health', { auth: false });
        if (!response.ok) throw new Error();
        const data = await response.json();
        if (isMounted) setStatus(data?.Status || 'ok');
      } catch {
        if (isMounted) setStatus('offline');
      }
    };

    check();

    return () => {
      isMounted = false;
    };
  }, [role]);

  if (role !== 'Administrator') return null;

  const chipColor = status === 'ok' ? 'success' : status === 'checking' ? 'default' : 'error';

  return (
    <Box sx={{ px: 2, pb: 2 }}>
      <MainCard sx={{ bgcolor: 'grey.50' }} contentSX={{ p: 1.5 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="caption" color="text.secondary">
            API Health
          </Typography>
          <Chip size="small" label={status.toUpperCase()} color={chipColor} />
        </Stack>
      </MainCard>
    </Box>
  );
}
